import React from 'react';
import { ChefHat, BookOpen, ConciergeBell } from 'lucide-react';
import { motion } from 'framer-motion';

const THEME_COLOR = '#c59253';

const SplashMobileView = ({ state }) => {
    const { siteInfo, splashData, spaces = [] } = state;
    const businessName = siteInfo?.businessName || 'Business Name';
    const logoPreview = siteInfo?.logoPreview;
    const firstSpaceName = spaces.length > 0 ? spaces[0].name : 'Space Name';

    const displayTitle = splashData?.title || `Space: ${firstSpaceName}`;
    const displaySubtitle = splashData?.subtitle || 'Choose and Order ... We will bring it to your table.';
    const menuButtonCaption = splashData?.menu_button_caption || 'Check menu';
    const actionButtonText = splashData?.action__button_text || 'Call waiter';

    return (
        <div className="h-100 bg-white d-flex flex-column align-items-center justify-content-between p-4 py-5 overflow-hidden position-relative">
            {/* Main Content */}
            <div className="w-100 d-flex flex-column align-items-center gap-4 mt-4">
                {/* Logo */}
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className="shadow-sm rounded-circle overflow-hidden border border-light"
                    style={{ width: '100px', height: '100px' }}
                >
                    {logoPreview ? (
                        <img src={logoPreview} alt="Logo" className="w-100 h-100 object-fit-cover" />
                    ) : (
                        <div className="w-100 h-100 bg-light d-flex align-items-center justify-content-center text-muted">
                            <ChefHat size={48} />
                        </div>
                    )}
                </motion.div>

                {/* Text Group */}
                <div className="text-center px-2">
                    <motion.h1
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2 }}
                        className="fw-bold mb-1"
                        style={{ fontSize: '1.25rem', color: '#111827' }}
                    >
                        {businessName}
                    </motion.h1>
                    <motion.p
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.3 }}
                        className="mb-0 px-3"
                        style={{ fontSize: '1rem', color: '#4b5563' }}
                    >
                        {displayTitle}
                    </motion.p>
                </div>

                {/* Divider */}
                <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: '100%' }}
                    transition={{ delay: 0.4 }}
                    className="bg-light"
                    style={{ height: '1px', maxWidth: '200px' }}
                />

                {/* Subtitle */}
                <motion.p
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.5 }}
                    className="text-center px-4 mb-4"
                    style={{ fontSize: '1rem', color: '#374151', lineHeight: '1.5' }}
                >
                    {displaySubtitle}
                </motion.p>

                {/* Buttons Group */}
                <div className="w-100 d-flex flex-column gap-3 px-3">
                    <motion.button
                        initial={{ x: -20, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.6 }}
                        className="btn w-100 py-3 rounded-pill fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
                        style={{
                            backgroundColor: THEME_COLOR,
                            color: 'white',
                            fontSize: '1.1rem',
                            border: 'none',
                            boxShadow: '0 10px 15px -3px rgba(197, 146, 83, 0.2)'
                        }}
                    >
                        <BookOpen size={20} />
                        {menuButtonCaption}
                    </motion.button>

                    {(splashData?.service_action_type || splashData?.menu_item_id) && (
                        <motion.button
                            initial={{ x: 20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.7 }}
                            className="btn w-100 py-3 rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2"
                            style={{
                                backgroundColor: '#f8fafc',
                                color: '#374151',
                                fontSize: '1.1rem',
                                border: '1.5px solid #e2e8f0',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
                            }}
                        >
                            <ConciergeBell size={20} />
                            {actionButtonText}
                        </motion.button>
                    )}
                </div>
            </div>

            {/* Footer */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1 }}
                className="text-center"
            >
                <span className="small text-muted" style={{ fontSize: '0.75rem' }}>Enabled by</span>
                <div className="fw-bold" style={{ fontSize: '0.85rem', letterSpacing: '1px' }}>
                    CLICK<span style={{ color: THEME_COLOR }}>ORDER</span>
                </div>
            </motion.div>
        </div>
    );
};

export default SplashMobileView;
